<div class="table-container">
	<h2 i18n="@@deviceAlertsMainTab-deviceAlerts">Device Alerts</h2>
	<div class="mat-list-div">
		@if (!isLoading() && enableSenturianFF && areThereAnyAlerts()) {
			<div class="inline-list">
				<mat-divider [vertical]="true"></mat-divider>
				@if (areThereAnyMissingKeyAlerts()) {
					<div class="mat-list-header" (click)="onTabClicked('missingKey')" data-automation-id="missing-key-tab">
						<div class="mat-list-div-text">
							<div class="mat-text">
								<span
									id="missingKey"
									i18n="@@deviceAlertsMainTab-missingKey"
									[ngClass]="{ 'active-text-label': selectedDeviceAlertType === MISSING_KEY }"
									>Missing Key</span
								>
							</div>
							<div>
								<span class="mat-device-alert-number"
									><b>{{ numMissingKey }}</b></span
								>
							</div>
						</div>
						<div>
							<mat-icon
								id="headerIconMissingKey"
								[ngClass]="{
									'active-icon': selectedDeviceAlertType === MISSING_KEY,
									'inactive-icon': selectedDeviceAlertType !== MISSING_KEY,
								}"
								matListIcon
								svgIcon="sl-missing-key"
							></mat-icon>
						</div>
					</div>
				}
				@if (areThereAnyMissingKeyAlerts()) {
					<mat-divider [vertical]="true"></mat-divider>
				}
				@if (areThereAnyLowBatteryAlerts()) {
					<div class="mat-list-header" (click)="onTabClicked('lowBattery')" data-automation-id="low-battery-tab">
						<div class="mat-list-div-text">
							<div class="mat-text">
								<span
									id="lowBattery"
									i18n="@@deviceAlertsMainTab-lowBattery"
									[ngClass]="{ 'active-text-label': selectedDeviceAlertType === LOW_BATTERY }"
									>Low Battery</span
								>
							</div>
							<div>
								<span class="mat-device-alert-number"
									><b>{{ numLowBattery }}</b></span
								>
							</div>
						</div>
						<div>
							<mat-icon
								id="headerIconLowBattery"
								[ngClass]="{
									'active-icon': selectedDeviceAlertType === LOW_BATTERY,
									'inactive-icon': selectedDeviceAlertType !== LOW_BATTERY,
								}"
								matListIcon
								svgIcon="sl-low-battery"
							></mat-icon>
						</div>
					</div>
				}
				@if (areThereAnyLowBatteryAlerts()) {
					<mat-divider [vertical]="true"></mat-divider>
				}
				@if (showKeyDetection && areThereAnyKeyNotDetectedAlerts()) {
					<div
						class="mat-list-header"
						(click)="onTabClicked('keyNotDetected')"
						data-automation-id="not-key-detected-tab"
					>
						<div class="mat-list-div-text">
							<div class="mat-text">
								<span
									id="keyNotDetected"
									i18n="@@deviceAlertsMainTab-keyNotDetected"
									[ngClass]="{ 'active-text-label': selectedDeviceAlertType === KEY_NOT_DETECTED }"
									>Key Not Detected</span
								>
							</div>
							<div>
								<span class="mat-device-alert-number"
									><b>{{ numKeyNotDetected }}</b></span
								>
							</div>
						</div>
						<div>
							<mat-icon
								id="headerIconKeyNotDetected"
								[ngClass]="{
									'active-icon': selectedDeviceAlertType === KEY_NOT_DETECTED,
									'inactive-icon': selectedDeviceAlertType !== KEY_NOT_DETECTED,
								}"
								matListIcon
								svgIcon="sl-key-not-detected"
							></mat-icon>
						</div>
					</div>
				}
				@if (showKeyDetection && areThereAnyKeyNotDetectedAlerts()) {
					<mat-divider [vertical]="true"></mat-divider>
				}
			</div>
		}

		@if (!isLoading() && !enableSenturianFF) {
			<div class="inline-list">
				<mat-divider [vertical]="true"></mat-divider>
				<div class="mat-list-header" (click)="onTabClicked('missingKey')" data-automation-id="missing-key-tab">
					<div class="mat-list-div-text">
						<div class="mat-text">
							<span
								id="missingKey"
								i18n="@@deviceAlertsMainTab-missingKey"
								[ngClass]="{ 'active-text-label': selectedDeviceAlertType === MISSING_KEY }"
								>Missing Key</span
							>
						</div>
						<div>
							<span class="mat-device-alert-number"
								><b>{{ numMissingKey }}</b></span
							>
						</div>
					</div>
					<div>
						<mat-icon
							id="headerIconMissingKey"
							[ngClass]="{
								'active-icon': selectedDeviceAlertType === MISSING_KEY,
								'inactive-icon': selectedDeviceAlertType !== MISSING_KEY,
							}"
							matListIcon
							svgIcon="sl-missing-key"
						></mat-icon>
					</div>
				</div>
				<mat-divider [vertical]="true"></mat-divider>
				<div class="mat-list-header" (click)="onTabClicked('lowBattery')" data-automation-id="low-battery-tab">
					<div class="mat-list-div-text">
						<div class="mat-text">
							<span
								id="lowBattery"
								i18n="@@deviceAlertsMainTab-lowBattery"
								[ngClass]="{ 'active-text-label': selectedDeviceAlertType === LOW_BATTERY }"
								>Low Battery</span
							>
						</div>
						<div>
							<span class="mat-device-alert-number"
								><b>{{ numLowBattery }}</b></span
							>
						</div>
					</div>
					<div>
						<mat-icon
							id="headerIconLowBattery"
							[ngClass]="{
								'active-icon': selectedDeviceAlertType === LOW_BATTERY,
								'inactive-icon': selectedDeviceAlertType !== LOW_BATTERY,
							}"
							matListIcon
							svgIcon="sl-low-battery"
						></mat-icon>
					</div>
				</div>
				<mat-divider [vertical]="true"></mat-divider>
				@if (showKeyDetection) {
					<div
						class="mat-list-header"
						(click)="onTabClicked('keyNotDetected')"
						data-automation-id="not-key-detected-tab"
					>
						<div class="mat-list-div-text">
							<div class="mat-text">
								<span
									id="keyNotDetected"
									i18n="@@deviceAlertsMainTab-keyNotDetected"
									[ngClass]="{ 'active-text-label': selectedDeviceAlertType === KEY_NOT_DETECTED }"
									>Key Not Detected</span
								>
							</div>
							<div>
								<span class="mat-device-alert-number"
									><b>{{ numKeyNotDetected }}</b></span
								>
							</div>
						</div>
						<div>
							<mat-icon
								id="headerIconKeyNotDetected"
								[ngClass]="{
									'active-icon': selectedDeviceAlertType === KEY_NOT_DETECTED,
									'inactive-icon': selectedDeviceAlertType !== KEY_NOT_DETECTED,
								}"
								matListIcon
								svgIcon="sl-key-not-detected"
							></mat-icon>
						</div>
					</div>
				}
				@if (showKeyDetection) {
					<mat-divider [vertical]="true"></mat-divider>
				}
			</div>
		}
	</div>
</div>

<div class="wrapper">
	<app-data-set #dataSet [dataSource]="dataSourceScrolling" [rowId]="rowId" firstColumnProperty="serialNumber">
		<app-data-set-content class="device-alert-contents">
			@if (isLoading()) {
				<app-data-set-loading-row />
			}
			<table
				mat-table
				[dataSource]="dataSourceScrolling"
				matSortActive="utcTriggerTime"
				matSortDirection="desc"
				matSort
				recycleRows
				[hidden]="isLoading()"
			>
				<tr class="mat-row" *matNoDataRow>
					<td class="mat-cell" [colSpan]="displayedColumns.length" i18n="@@deviceAlertsMainTab-noCurrentAlerts">
						No current alerts.
					</td>
				</tr>

				<ng-container matColumnDef="deviceAlertType">
					<th mat-header-cell *matHeaderCellDef i18n="@@deviceAlertsMainTab-TypeRow">Type</th>
					<td mat-cell *matCellDef="let row">
						<div style="width: 100%; display: table">
							<div class="mat-cell-text" style="display: table-row">
								<div style="width: 50px; display: table-cell">
									@if (row.deviceAlertType.indexOf(LOW_BATTERY) !== -1) {
										<mat-icon style="width: 30px; height: 30px" svgIcon="sl-low-battery"></mat-icon>
									}
									@if (row.deviceAlertType.indexOf(MISSING_KEY) !== -1) {
										<mat-icon style="width: 35px; height: 35px" svgIcon="sl-missing-key"></mat-icon>
									}
									@if (row.deviceAlertType.indexOf(KEY_NOT_DETECTED) !== -1 && showKeyDetection) {
										<mat-icon style="width: 35px; height: 35px" svgIcon="sl-key-not-detected"></mat-icon>
									}
								</div>
								@for (type of map | keyvalue; track type.key) {
									<div>
										@if (
											type.key.includes(row.deviceAlertType) && type.key.includes(row.serialNumber) && type.value > 1
										) {
											<span class="ticker-text">+{{ type.value }}</span>
										}
									</div>
								}
							</div>
						</div>
					</td>
				</ng-container>

				<ng-container matColumnDef="serialNumber">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@deviceAlertsMainTab-serialNumber">
						Serial Number
					</th>
					<td mat-cell *matCellDef="let row">
						<div class="mat-cell-text">
							<div [innerHtml]="row.serialNumber"></div>
						</div>
					</td>
				</ng-container>

				<ng-container matColumnDef="propertyName">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@deviceAlertsMainTab-propertyName">
						Property Name
					</th>
					<td mat-cell *matCellDef="let row">
						<div class="mat-cell-text">
							<div [innerHtml]="row.propertyName"></div>
						</div>
					</td>
				</ng-container>

				<ng-container matColumnDef="location">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@deviceAlertsMainTab-location">Location</th>
					<td mat-cell *matCellDef="let row">
						<div class="mat-cell-text">
							<div [innerHtml]="row.location"></div>
						</div>
					</td>
				</ng-container>

				<ng-container matColumnDef="utcTriggerTime">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@deviceAlertsMainTab-utcTriggerTime">
						Timestamp
					</th>
					<td mat-cell *matCellDef="let row">
						<div>
							<div class="mat-cell-text">
								<div>
									{{
										row.utcTriggerTime
											| date: 'mediumDate' : timeZoneService.utcOffset(row.utcTriggerTime, row.locationTimeZone)
									}},
									{{
										row.utcTriggerTime
											| date: 'shortTime' : timeZoneService.utcOffset(row.utcTriggerTime, row.locationTimeZone)
									}}
									{{ row.locationTimeZone | shortNamedOffset }}
								</div>
							</div>
						</div>
					</td>
				</ng-container>

				<ng-container matColumnDef="rowMenu">
					<th mat-header-cell *matHeaderCellDef></th>
					<td mat-cell *matCellDef="let row">
						<app-data-set-table-menu
							[menu]="menu"
							[row]="row"
							[attr.data-automation-id]="'device-alerts-row-button' + row.id"
						></app-data-set-table-menu>
					</td>
				</ng-container>
				<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
				<tr
					mat-row
					*matRowDef="let row; columns: displayedColumns"
					(click)="onRowClick(row)"
					[attr.data-automation-id]="'device-alerts-row-' + row.id"
				></tr>
			</table>

			<div id="viewAllButton"></div>
			<mat-menu #menu="matMenu">
				<ng-template matMenuContent let-row="row">
					<button
						mat-menu-item
						(click)="dismissAlert(row)"
						i18n="@@deviceAlertsMainTab-dismissAlert"
						data-automation-id="device-alerts-dismiss-button"
					>
						Dismiss
					</button>
				</ng-template>
			</mat-menu>
		</app-data-set-content>
	</app-data-set>
</div>
